export default __webpack_public_path__ + "static/media/List-documentation.f398b94e.md";